import React, { useState, useEffect } from 'react'
import { CardDrawer } from '../../../../../../../../../../components/Card'
import Icon from '../../../../../../../../../../components/Icon'
import Buttons from '../../../../../../../../../../modules/Buttons'
import Button from '../../../../../../../../../../components/inputs/Button'
import DatePicker from '../../../../../../../../../../components/DatePicker'
import moment from 'moment'
import { useFetch } from '../../../../../../../../../../hooks';
import { isNil } from 'ramda'
import Wrapper from '../../../../../../../../../../components/Wrapper'

function ExpectedBirth({ rowid, expectedBirth, refetchCow }) {

    const { doFetch: doFetchSetLastBirth } = useFetch({
        url: '/rpc/setbirthexpected',
        method: 'POST'
    })

    const [expectedBirthDate, setExpectedBirthDate] = useState(expectedBirth.value ? moment.unix(expectedBirth.value)._d : moment()._d);

    useEffect(() => {
        if (!isNil(expectedBirth.value)) {
            setExpectedBirthDate(moment.unix(expectedBirth.value)._d)
        } else {
            setExpectedBirthDate(moment()._d)
        }
    }, [expectedBirth])

    const handleClickSetExpectedBirth = async () => {
        try {
            await doFetchSetLastBirth({
                data: {
                    rowid,
                    dt: moment(expectedBirthDate).unix()
                }
            })
            await refetchCow({ loader: false })
        } catch (err) {
            console.log(err)
        }
    }

    const handleClickRemove = () => {
        setExpectedBirthDate(0)
    }

    return (
        <CardDrawer
            name={expectedBirth.title}
            value={expectedBirth.info ? expectedBirth.info : '----'}
            renderOpenButton={({ handleToggleIsOpenDrawer }) => <Button noMargin onClick={handleToggleIsOpenDrawer}><Icon name='edit' /></Button>}
            renderContentDrawer={({ handleToggleIsOpenDrawer }) => (
                <>
                    <Wrapper noMargin>
                        <DatePicker
                            selected={expectedBirthDate}
                            onChange={date => setExpectedBirthDate(date)}
                            dateFormat="dd.MM.yyyy"
                        />
                        <Button onClick={handleClickRemove}>
                            <Icon name="remove" />
                        </Button>
                    </Wrapper>
                    <Buttons>
                        <Button
                            type='button'
                            onClick={handleToggleIsOpenDrawer}
                            width='50%'
                        >
                            {expectedBirth.buttons.cancel}
                        </Button>
                        <Button
                            type='button'
                            onClick={() => {
                                handleClickSetExpectedBirth();
                                handleToggleIsOpenDrawer();
                            }}
                            width='50%'
                            green
                        >
                            {expectedBirth.buttons.save}
                        </Button>
                    </Buttons>
                </>
            )}
        />
    )
}

export default ExpectedBirth
